import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { ErrorService } from './error.service';
@Injectable()
export class UnhandledErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) { }
  handleError(err: any): void {
    try {
      const _errorService = this.injector.get(ErrorService);
      _errorService.errorHandlerAsObservable(err);
    }
    catch{
      console.log(err);
    }
  }
}